<div class="consulta-protocolo-page">
    <app-card-content [icon]="'pi pi-search'" [title]="'Consultar Protocolo'" [subtitle]="'Selecione o tipo de servico e informe o protocolo para visualizar apenas o registro encontrado.'">
        <form class="consulta-protocolo-form" (ngSubmit)="consultarProtocolo()">
            <label class="consulta-protocolo-field" for="servico">
                <span>Tipo de serviço</span>
                <p-select
                    inputId="servico"
                    name="codigoServicoSelecionado"
                    [options]="servicosDisponiveis()"
                    [ngModel]="codigoServicoSelecionado()"
                    (ngModelChange)="onServicoSelecionadoChange($event)"
                    optionLabel="rotulo"
                    optionValue="codigo"
                    placeholder="Selecione"
                    appendTo="body"
                    class="w-full"
                    [disabled]="carregandoConsultaProtocolo || carregandoCatalogo"
                ></p-select>
            </label>

            <label class="consulta-protocolo-field" for="numero-protocolo">
                <span>Número do protocolo</span>
                <input id="numero-protocolo" name="numeroProtocolo" type="text" pInputText inputmode="numeric" autocomplete="off" [ngModel]="numeroProtocolo()" (ngModelChange)="numeroProtocolo.set($event)" [disabled]="carregandoConsultaProtocolo" />
            </label>

            <label class="consulta-protocolo-field" for="ano-protocolo">
                <span>Ano</span>
                <input
                    id="ano-protocolo"
                    name="anoProtocolo"
                    type="text"
                    pInputText
                    inputmode="numeric"
                    maxlength="4"
                    autocomplete="off"
                    [ngModel]="anoProtocolo()"
                    (ngModelChange)="anoProtocolo.set($event)"
                    [disabled]="carregandoConsultaProtocolo"
                />
            </label>

            <button pButton type="submit" icon="pi pi-search" label="Consultar" class="consulta-protocolo-botao" [loading]="carregandoConsultaProtocolo" [disabled]="carregandoConsultaProtocolo"></button>
        </form>

        @if (erroValidacao() || erroConsultaProtocolo) {
            <p class="consulta-protocolo-erro">{{ erroValidacao() || erroConsultaProtocolo }}</p>
        }
    </app-card-content>

    @if (protocoloSelecionado(); as protocoloSelecionado) {
        <section class="consulta-protocolo-resultado">
            <app-card-content [icon]="'pi pi-id-card'" [title]="'Protocolo Portal'" [subtitle]="protocoloSelecionado.portal">
                <div class="detail-card-body">
                    <div class="detail-card-field">
                        <span class="detail-card-label detail-card-field-label"><strong>Solicitante</strong></span>
                        <span class="detail-card-value detail-card-value-strong">{{ unidadeNome() }}</span>
                    </div>

                    @if (codigoEstado()) {
                        <div class="detail-card-field">
                            <span class="detail-card-label detail-card-field-label"><strong>CRM/UF</strong></span>
                            <div class="detail-card-crm">
                                <span class="crm-value">{{ codigoEstado() }}</span>
                            </div>
                        </div>
                    }

                    <div class="detail-card-field">
                        <span class="detail-card-label detail-card-field-label"><strong>Status</strong></span>
                        <div class="detail-card-status">
                            <span class="detail-situacao" [class]="situacaoProtocoloClasse(protocoloSelecionado.situacaoCodigo)">
                                {{ situacaoProtocoloRotulo(protocoloSelecionado.situacaoCodigo) }}
                            </span>
                            @if (protocoloSelecionado.inPago === false) {
                                <span class="detail-badge-pagamento nao-pago">Não pago</span>
                            }
                            @if (protocoloSelecionado.isAnuidadePaga === false) {
                                <span class="detail-badge-pagamento anuidade-nao-paga">Anuidade não paga</span>
                            }
                        </div>
                    </div>
                </div>
            </app-card-content>

            <app-card-servicos [unidadeNome]="unidadeNome()" [codigoEstado]="codigoEstado()" [showEmail]="false" [selectedCodigo]="codigoServicoResultado()" [protocoloSelecionado]="protocoloSelecionado" [exibirAcoes]="false"></app-card-servicos>
        </section>
    }
</div>
